import { render } from "./TvmVDVIcon.vue?vue&type=template&id=c9cf80a8"
import script from "./TvmVDVIcon.vue?vue&type=script&lang=js"
export * from "./TvmVDVIcon.vue?vue&type=script&lang=js"

import "./TvmVDVIcon.vue?vue&type=style&index=0&id=c9cf80a8&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Components/ChatWidget/TvmVDVIcon/TvmVDVIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c9cf80a8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c9cf80a8', __exports__)) {
    api.reload('c9cf80a8', __exports__)
  }
  
  module.hot.accept("./TvmVDVIcon.vue?vue&type=template&id=c9cf80a8", () => {
    api.rerender('c9cf80a8', render)
  })

}


export default __exports__